exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\niframe[data-v-44538763]{width:100vw;height:100vh\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/filePreview.vue"],"names":[],"mappings":";AAkBA,wBACI,YACA,YAAa;CAChB","file":"filePreview.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\niframe{\n    width: 100vw;\n    height: 100vh;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44538763","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/filePreview.vue
// module id = d2Bq
// module chunks = 96